import { useVisitorTracking } from "@/hooks/useVisitorTracking";

const VisitorTracker = () => {
  useVisitorTracking();
  return null;
};

export default VisitorTracker;
